if (!customElements.get('as-seen-on')) {
  class TG_AsSeenOn extends HTMLElement {
    connectedCallback() {
      this._initCarousel();
      this._onVariantChanged = this._onVariantChanged.bind(this);
      document.addEventListener('variant:changed', this._onVariantChanged);
    }

    disconnectedCallback() {
      if (this.carousel) this.carousel.destroy();
      document.removeEventListener('variant:changed', this._onVariantChanged);
    }

    _initCarousel() {
      const carouselElement = this.querySelector('.Carousel');
      if (carouselElement) {
        this.carousel = new themegoal.components.Carousel(carouselElement);
      }
    }

    _onVariantChanged(event) {
      const variant = event.detail && event.detail.variant;
      const productUrl = this.dataset.productUrl;
      const sectionId = this.dataset.sectionId;
      if (!variant || !productUrl || !sectionId) return;

      const _this = this;
      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sourceSection = doc.querySelector('#section-' + sectionId);
          const hasSlides = !!sourceSection && sourceSection.dataset.hasSlides === 'true';

          // No image/video for this variant: hide the whole section.
          _this.dataset.hasSlides = String(hasSlides);
          _this.style.display = hasSlides ? 'block' : 'none';
          if (!hasSlides) {
            if (_this.carousel) _this.carousel.destroy();
            _this.carousel = null;
            return;
          }

          const sourceWrapper = sourceSection.querySelector('.CarouselWrapper');
          const destinationWrapper = _this.querySelector('.CarouselWrapper');
          if (!sourceWrapper || !destinationWrapper) return;

          destinationWrapper.innerHTML = sourceWrapper.innerHTML;
          if (_this.carousel) _this.carousel.destroy();
          _this._initCarousel();
        });
    }
  }

  customElements.define('as-seen-on', TG_AsSeenOn);
}
